import { render } from "./RotaSelect.vue?vue&type=template&id=9a22d3d8&ts=true"
import script from "./RotaSelect.vue?vue&type=script&lang=ts"
export * from "./RotaSelect.vue?vue&type=script&lang=ts"

import "./RotaSelect.vue?vue&type=style&index=0&id=9a22d3d8&lang=css"

import exportComponent from "F:\\Projetos 2024\\e-logDash\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__